<zag-collection-layout
  [items]="notifications()"
  [trackBy]="trackById"
  [config]="collectionConfig"
  [loading]="isLoading()"
  [error]="error()"
  [totalCount]="total()"
  [filterValues]="filterValues()"
  (filterValuesChange)="onFilterChange($event)"
  (retry)="onRetry()"
>
  <!-- Quick Actions: mark all as read -->
  @if (hasUnread()) {
    <ng-template #headerContent>
      <button
        class="zag-collection-layout__action-btn"
        type="button"
        [disabled]="isMarkingAll()"
        [attr.aria-busy]="isMarkingAll()"
        (click)="onMarkAllAsRead()"
      >
        <span zagIcon="done_all"></span>
        {{ 'notifications.markAllAsRead' | translate }}
      </button>
    </ng-template>
  }

  <!-- Card view -->
  <ng-template #cardTemplate let-notification>
    <a class="notification-list__item-link notification-list__item-link--card" href="#" (click)="onNotificationClick(notification, $event)">
      <zag-notification-item
        [notification]="notification"
        [showActions]="true"
        (markAsRead)="onMarkAsRead($event)"
        (archive)="onArchive($event)"
      />
    </a>
  </ng-template>

  <!-- List item row -->
  <ng-template #listTemplate let-notification>
    <a class="notification-list__item-link" href="#" (click)="onNotificationClick(notification, $event)">
      <zag-notification-item
        [notification]="notification"
        [showActions]="true"
        (markAsRead)="onMarkAsRead($event)"
        (archive)="onArchive($event)"
      />
    </a>
  </ng-template>

  <!-- Empty state -->
  <ng-template #emptyContent>
    <span zagIcon="notifications_off"></span>
    <p>{{ 'notifications.empty' | translate }}</p>
    <p>{{ 'notifications.emptyDescription' | translate }}</p>
  </ng-template>
</zag-collection-layout>
